import { createStore, applyMiddleware } from 'redux';
import { persistStore, persistReducer } from 'redux-persist';
import thunk from 'redux-thunk';
import storage from 'redux-persist/lib/storage';
import rootReducer from './reducers';

const rootPersistConfig = {
  key: 'root',
  storage,
  whitelist: [],
};

const store = createStore(
  persistReducer(rootPersistConfig, rootReducer),
  applyMiddleware(thunk),
);

const persistor = persistStore(store);

export { store, persistor };
